import { chessSpyders_tilemap_piece } from './chessSpyders_tilemap_piece-sidecar'

export function updateAll() {
  chessSpyders_tilemap_piece.runSpyder()
}
